// Vendors
import React from 'react';
// Components
import { EntrypointOrchestratorComponent } from './components/orchestrator/entrypoint-orchestrator.component';
// Contexts
import { useStylesContextConsumerHook } from 'contexts/styles.context';
// Styles
import { EntrypointContentComponentStyled } from './entrypoint.component.styled';

const EntrypointComponent = (): React.JSX.Element => {
  const { paddingContent } = useStylesContextConsumerHook();

  return (
    <EntrypointContentComponentStyled {...{ paddingContent }}>
      <EntrypointOrchestratorComponent />
    </EntrypointContentComponentStyled>
  );
};

export { EntrypointComponent };
